<template>
  <q-table v-model="table" :multiple="true" :rows="rows"></q-table>
</template>

<script>
import QTable from "./QTable.vue";
export default {
  components: { QTable },
  data() {
    return {
      rows: [
        { key: "platformName", label: "平台名称" },
        { key: "platformUrl", label: "平台链接" }
      ],
      table: []
    };
  }
};
</script>
